// extracted by mini-css-extract-plugin
export var closeButton = "_bv-1";
export var closeX = "_bv-3";
export var container = "_bv-0";
export var image = "_bv-2";